import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const ModDrugOrderTemplate = (props: any) => {
    return(
      <div>
        <div
          id="ModDrugOrderTemplate-div-1">
          
          <div
            id="ModDrugOrderTemplate-div-16"
            style={{padding: "15px"}}>
            
            <div
              id="ModDrugOrderTemplate-Div-DrugOrderTemplateScreen"
              style={{display: "flex", alignItems: "center"}}>
              <div
                id="ModDrugOrderTemplate-div-18"
                style={{fontWeight: "bold", fontSize: "20px", flex: "1"}}>
                {props.languageUX === "en" ? "Order medicine from the doctor's medicine kit" : "สั่งยาจากชุดยาของแพทย์"}
              </div>
              <div
                id="ModDrugOrderTemplate-div-44"
                style={{display: "flex", flex: "2", paddingLeft: "20px"}}>
                
                <Button
                  className={props.selectTab === "doctor" ? "" : "inverted"}
                  color="blue"
                  id="ModDrugOrderTemplate-Button-45"
                  onClick={() => {props.onChangeTab("doctor")}}>
                  {props.languageUX === "en" ? "Doctor's kit" : "ชุดยาของแพทย์"}
                </Button>
                <Button
                  className={props.selectTab === "central" ? "" : "inverted"}
                  color="blue"
                  id="ModDrugOrderTemplate-Button-46"
                  onClick={() => {props.onChangeTab("central")}}>
                  {props.languageUX === "en" ? "Central medicine kit" : "ชุดยาส่วนกลาง"}
                </Button>
              </div>
            </div>
            <div
              id="ModDrugOrderTemplate-div-43">
              {props.dividerProps}
            </div>
            <div
              id="ModDrugOrderTemplate-div-20"
              style={{display: "flex", alignItems: "center", padding: "10px 0px"}}>
              
              <div
                id="ModDrugOrderTemplate-div-37"
                style={{display: "flex", alignItems: "center",  flex: "1",}}>
                
                <label
                  id="ModDrugOrderTemplate-label-40"
                  style={{paddingRight: "10px"}}>
                  {props.languageUX === "en" ? "Find medicine kit" : "ค้นหาชุดยา"}
                </label>
                <Input
                  icon="search"
                  id="ModDrugOrderTemplate-Input-SearchTemplate"
                  onChange={props.onChangeSearchText}
                  style={{width: "280px"}}
                  value={props.searchText}>
                </Input>
                <Button
                  color="blue"
                  id="ModDrugOrderTemplate-Button-42"
                  onClick={props.onSearch}
                  style={{marginLeft: "10px"}}>
                  {props.languageUX === "en" ? "Search" : "ค้นหา"}
                </Button>
              </div>
              <div
                id="ModDrugOrderTemplate-div-38"
                style={{display: "flex", justifyContent:  "flex-end", flex: 2}}>
                
                <Button
                  color="blue"
                  id="ModDrugOrderTemplate-Button-39"
                  onClick={props.onDrugOrderTemplate}>
                  {props.languageUX === "en" ? "Drug kit management" : "การจัดการชุดยา"}
                </Button>
              </div>
            </div>
            <div
              id="ModDrugOrderTemplate-div-22"
              style={{display: "flex"}}>
              <div
                id="ModDrugOrderTemplate-div-31"
                style={{flex: 1}}>
                
                <Table
                  data={props.drugOrderTemplateData}
                  getTrProps={props.drugOrderTrProps}
                  headers={props.selectTab === "central" ?  ",ชุดยา," : ",ชุดยา"}
                  id="ModDrugOrderTemplate-Table-34"
                  keys={props.selectTab === "central" ? "_checkbox,name,pinned" : "_checkbox,name"}
                  minRows="8"
                  showPagination={false}
                  style={{ height: "50vh" }}
                  widths={props.selectTab === "central" ? "50,,100" : "50,"}>
                </Table>
              </div>
              <div
                id="ModDrugOrderTemplate-div-33"
                style={{flex: 2, paddingLeft: "20px"}}>
                
                <Table
                  data={props.drugTemplate}
                  getTrProps={props.drugItemSelectRow}
                  headers={props.drugItemHeader?  props.drugItemHeader :",ชื่อยา,วิธีใช้,จำนวน,หน่วย"}
                  id="ModDrugOrderTemplate-Table-35"
                  keys="_check,drug_name_from_format,prescription_label,quantity,stock_unit_name"
                  minRows="8"
                  showPagination={false}
                  style={{ height: "50vh" }}
                  widths="50,,,100,100">
                </Table>
              </div>
            </div>
            <div
              id="ModDrugOrderTemplate-div-26"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "25px"}}>
              <Button
                color="blue"
                id="ModDrugOrderTemplate-Button-27"
                onClick={props.onAddToOrder}>
                {props.languageUX === "en" ? "ADD TO ORDER" : "เพิ่มลงในคำสั่งซื้อ"}
              </Button>
              <Button
                color="grey"
                id="ModDrugOrderTemplate-Button-36"
                onClick={props.onCancel}>
                {props.languageUX === "en" ? "CANCEL" : "ยกเลิก"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
}


export default ModDrugOrderTemplate

export const screenPropsDefault = {}

/* Date Time : Wed Oct 01 2025 12:12:21 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-1"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-16"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Div-DrugOrderTemplateScreen"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "สั่งยาจากชุดยาของแพทย์",
          "valueEN": "Order medicine from the doctor's medicine kit"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-18"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"20px\", flex: \"1\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-20"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", padding: \"10px 0px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-22"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-26"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"25px\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Button",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มลงในคำสั่งซื้อ",
          "valueEN": "ADD TO ORDER"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Button-27"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddToOrder"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-31"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-33"
        },
        "style": {
          "type": "code",
          "value": "{flex: 2, paddingLeft: \"20px\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 34,
      "name": "Table",
      "parent": 31,
      "props": {
        "columns": {
          "type": "code",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.drugOrderTemplateData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.drugOrderTrProps"
        },
        "headers": {
          "type": "code",
          "value": "props.selectTab === \"central\" ?  \",ชุดยา,\" : \",ชุดยา\""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Table-34"
        },
        "keys": {
          "type": "code",
          "value": "props.selectTab === \"central\" ? \"_checkbox,name,pinned\" : \"_checkbox,name\""
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50vh\" }"
        },
        "widths": {
          "type": "code",
          "value": "props.selectTab === \"central\" ? \"50,,100\" : \"50,\""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 35,
      "name": "Table",
      "parent": 33,
      "props": {
        "data": {
          "type": "code",
          "value": "props.drugTemplate"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.drugItemSelectRow"
        },
        "headers": {
          "type": "code",
          "value": "props.drugItemHeader?  props.drugItemHeader :\",ชื่อยา,วิธีใช้,จำนวน,หน่วย\""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Table-35"
        },
        "keys": {
          "type": "value",
          "value": "_check,drug_name_from_format,prescription_label,quantity,stock_unit_name"
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50vh\" }"
        },
        "widths": {
          "type": "value",
          "value": "50,,,100,100"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Button",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "grey"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Button-36"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancel"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-37"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\",  flex: \"1\",}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-38"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent:  \"flex-end\", flex: 2}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Button",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "การจัดการชุดยา",
          "valueEN": "Drug kit management"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Button-39"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDrugOrderTemplate"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาชุดยา",
          "valueEN": "Find medicine kit"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-label-40"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"10px\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "Input",
      "parent": 37,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Input-SearchTemplate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSearchText"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"280px\"}"
        },
        "value": {
          "type": "code",
          "value": "props.searchText"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Button",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Button-42"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearch"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dividerProps"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-43"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-div-44"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", flex: \"2\", paddingLeft: \"20px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "Button",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "ชุดยาของแพทย์",
          "valueEN": "Doctor's kit"
        },
        "className": {
          "type": "code",
          "value": "props.selectTab === \"doctor\" ? \"\" : \"inverted\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Button-45"
        },
        "onClick": {
          "type": "code",
          "value": "() => {props.onChangeTab(\"doctor\")}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Button",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "ชุดยาส่วนกลาง",
          "valueEN": "Central medicine kit"
        },
        "className": {
          "type": "code",
          "value": "props.selectTab === \"central\" ? \"\" : \"inverted\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModDrugOrderTemplate-Button-46"
        },
        "onClick": {
          "type": "code",
          "value": "() => {props.onChangeTab(\"central\")}"
        }
      },
      "seq": 46,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "ModDrugOrderTemplate",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
